import { render, staticRenderFns } from "./HeatMapChart.vue?vue&type=template&id=ec012156"
import script from "./HeatMapChart.vue?vue&type=script&lang=js"
export * from "./HeatMapChart.vue?vue&type=script&lang=js"
import style0 from "./HeatMapChart.vue?vue&type=style&index=0&id=ec012156&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports